 
import React, {useState} from 'react';
import {HTTP_STATUS_OK} from '../../../smartpak/httpstatus';
import {antiForgeryPost} from '../../../utils/fetch';

const AddToCart = ({products}) => {
    const [isSaving, setIsSaving] = useState(false);
    function errorModal(message) {
        let container = document.createElement('div');
        container.append(message);
        smartPak.ui.modal(container, {
            title: 'Error processing request',
            buttons: {
                'I understand': function (modal) {
                    modal.close();
                }
            }
        });
    }

    function handleClick() {
        setIsSaving(true);

        products.length >= 1
            ? addProductsToCart(products)
            : errorModal('Please select at least one product to continue.');
    }

    function addProductsToCart(products) {
        const productData = products.map(item => {
            const quantity = 1;
            return `${item},${quantity}`;
        });

        antiForgeryPost(`/api/shoppingcart/addsupplyitemstocart`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productData)
        }).then(response => {
            if (response.status === HTTP_STATUS_OK) {
                location.href = '/cart';
            } else {
                errorModal(
                    'We were unable to process this request. Please try again or give us a call at 1-800-461-8898.'
                );
                setIsSaving(false);
            }
        });
    }

    return (
        <button className="purchase button bridle-add" onClick={handleClick} disabled={isSaving}>
            Add To Cart
        </button>
    );
};

export default AddToCart;
